import { alpha, Theme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/DeleteOutlineRounded';
import { FormNumberTextField } from 'components/@shared/Form/FormNumberTextField';
import { FormTextField } from 'components/@shared/Form/TextField';
import { memo, useCallback } from 'react';

interface Props {
    id: string;
    disableDelete: boolean;
    index: number;
    onDelete: (id: string) => void;
}

const boxStyles = (theme: Theme) => ({
    borderColor: 'primary.main',
    borderWidth: 1,
    borderStyle: 'solid',
    backgroundColor: alpha(theme.palette.primary.light, 0.2),
    borderRadius: '4px',
});

export const ProposalFormItem = memo(({ id, index, disableDelete, onDelete }: Props) => (
    <Box px={1} py={1.5} sx={boxStyles}>
        <Grid container spacing={2} mb={2}>
            <Grid item xs={12} sm={6}>
                <FormTextField name={`lineItems.${index}.name`} label="Name" fullWidth size="small" />
            </Grid>
            <Grid item xs={12} sm={5}>
                <FormNumberTextField
                    prefix="$"
                    name={`lineItems.${index}.total`}
                    label="Price"
                    fullWidth
                    size="small"
                />
            </Grid>
            <Grid item xs={12} sm={1}>
                <IconButton color="error" disabled={disableDelete}>
                    <DeleteIcon onClick={() => onDelete(id)} />
                </IconButton>
            </Grid>
        </Grid>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormTextField
                    name={`lineItems.${index}.description`}
                    label="Description"
                    fullWidth
                    size="small"
                    multiline
                    rows={3}
                />
            </Grid>
        </Grid>
    </Box>
));

ProposalFormItem.displayName = 'ProposalFormItem';
